export default {
    to: 'por',
    from: 'de',
    IWant: 'Eu Quero!',
    learnMore: 'Saiba Mais',
    logoAlt: 'Logo Astrolink',
    unlockNow: 'Desbloquear agora!',
    subscribeNow: 'Assine Agora!',
    alPremium: 'Astrolink Premium',
    bePremium: 'Seja <b>Premium</b> no <b>Astrolink</b>',
    creditOnly: 'Oferta exclusiva apenas no cartão de crédito',

    intro: {
        wannaBePremium: 'Quero ser Premium!',
        firstMonthOnly: '<b>{price}</b> no primeiro mês!',
        cancelAtWill: 'Cancele quando desejar!',
        seeAnotherOptions: 'veja outras opções',
        fromPrice: '<s>De {price}</s> por',
        firstMonth: 'no primeiro mês!',
        otherPayMethods: 'Outras formas de pagamento',
        otherPayMethodsNoPromo: 'Outras formas de pagamento sem promoção',
        countdownInfo: 'A promoção acaba em<br/><strong>{countdown}</strong>',
        cancelAtWillCredit: 'Cancele quando desejar <br /> Oferta exclusiva no cartão de crédito'
    },

    comparison: {
        two: '2',
        free: 'Grátis',
        premium: 'Premium',
        unlimited: 'ilimitado',
        extra: 'Mapas Extras',
        guide: 'Guia 2025',
        biorhythm: 'Biorritmo',
        moonCicle: 'Ciclo Lunar',
        tarot: 'Tarot ilimitado',
        future: 'Horóscopo Futuro',
        moonNodes: 'Nodos Lunares',
        banner: 'Bandeira {banner}',
        guides: 'Guias astrológicos',
        orbia: 'Orbia / IA Astrológica',
        complete: 'Mapa Astral completo',
        noAds: 'Experiência sem anúncios',
        sinastry: 'Compatibilidade Astral',
        horoscope: 'Horóscopo personalizado',
        cardOption: 'E mais 10 opções de cartões',
        unlock: 'Veja o que você vai desbloquear!',
        anotherForms: 'Outras formas de pagamento',
        compatibility: 'Compatibilidade / Sinastria',
        signFor: '<span>Assinar por {price}</span><small>no primeiro mês</small>'
    },

    selection: {
        month: '/mês',
        currency: 'R$',
        bestChoice: 'Melhor escolha',
        monthly: 'Plano <b>MENSAL</b>',
        chargeMonth: 'Cobrança mensal',
        semiannual: 'Plano <b>SEMESTRAL</b>',
        goToPayment: 'Prosseguir ao pagamento',
        cancelAtWill: 'Você pode cancelar quando desejar!',
        chooseAPlanReverse: 'Para prosseguir, <strong>escolha seu plano ideal</strong>',
        chooseAPlan: '<strong>Escolha o plano ideal</strong> para você, para prosseguir:',
        chooseRenewPlan: 'Escolha o plano ideal para renovar <br /><strong>a partir do segundo mês:</strong>',
        chargeFor: {
            title: 'Cobrança de {price} por',
            month: 'mês',
            quarterly: 'trimestre',
            semiannual: 'semestre'
        }
    },

    lovetarot: {
        follow: 'Acompanhe o',
        dontLose: 'Não perca a promoção',
        text: 'Texto escrito tarot do amor',
        trustAnwser: 'Confie nas respostas do',
        backCard: 'Verso de uma carta de tarot',
        coloredHearts: 'Vários corações coloridos',
        chanceToDestiny: 'Em 2022, dê uma chance pro <br /> destino te ajudar.',
        floatingDeck: 'Desenho de mãos abertas com um baralho de tarot flutuando em cima',

        intro: {
            button: 'Quero Ser Premium!',
            modalMessage: '<b>Tiragens e interpretações específicas</b> para as perguntas relacionadas a amor.'
        }
    },

    countdown: {
        price: 'Premium por {price}*',
        limitedTime: 'por tempo limitado!',
        learnMore: 'Saiba Mais',
        wannaEnjoy: 'Quero Aproveitar!',
        imageAlt: 'Expressão tá na hora!',
        hour: 'horas',
        minute: 'minutos',
        second: 'segundos',
        discountOffer: 'Desconto <strong>Imperdível</strong>!',
        discountText:
            '<strong>75% de desconto</strong> no primeiro mês* para te ajudar a iniciar sua jornada. É por tempo limitado!',
        astrolinkPremium: 'Astrolink Premium',
        firstMonth: 'Seu primeiro mês por {price} já está garantido!',
        chooseAPlan: 'Agora escolha seu plano ideal:',
        cancelAtWill: 'Cancele quando desejar!'
    },

    static: {
        guide2024: {
            logo: 'logo-{media}{complement}.webp',
            attractiveText:
                'Previsões Pessoais, Astrologia Mundial, Tarot, Calendário Lunar, Numerologia do Ano, Artigos sobre 2024 e mais!'
        }
    },

    trial: {
        title: 'Experimente o Astrolink Premium de graça!',

        bar: {
            button: 'Aproveite agora!',
            description: 'Desbloqueie a experiência ilimitada completa'
        },

        modal: {
            giftTag: 'PRESENTE DE BOAS-VINDAS PARA VOCÊ',
            expansiveTrigger: 'Veja mais 10 vantagens',
            description: 'Desbloqueie a experiência completa e ilimitada por 3 dias',
            renewalNotice:
                'A assinatura é renovada automaticamente após o período de teste. Cancele a qualquer momento.',

            button: `
                <strong>Comece um teste grátis de 3 dias</strong>
                <p>depois {priceWithCurrency}/semestralmente</p>
            `,
            buttonIos: `
                <strong>Comece um teste grátis de 3 dias</strong>
            `,

            advantages: `
                Mapa Astral completo e personalizado;
                Horóscopos diários e futuros;
                Leituras de Tarot Tradicional e do Amor;
                Compatibilidade Amorosa;
                Mapas Astrais Extras;
                Análise de Biorritmo;
                Área Pessoal;
                Nódulos Lunares: Caminho da Evolução;
                Conhecimento Astrológico;
                Mapa Astral Resumido;
                Ciclo Lunar Detalhado
            `
        }
    },

    synas: {
        default: {
            tools: {
                text: '<strong>Encontre o amor</strong> com a ajuda dos astros no <span>app Synas</span>',
                cta: 'Encontrar meu par'
            },

            informative: {
                text: '<small>Seu <strong>par perfeito</strong> está a um <strong>mapa astral</strong> de distância</small><br /><strong>Encontre seu match no <span>app Synas</span></strong>',
                cta: 'Encontrar meu par'
            }
        },
        valentines: {
            tools: {
                text: 'Neste <strong><span>Dia dos Namorados</span></strong>, deixe os <strong>astros guiarem seu amor</strong> no <strong>Synas</strong>!',
                cta: 'Encontrar meu par'
            },

            informative: {
                text: 'Neste <strong><span>Dia dos Namorados</span></strong>, deixe os <strong>astros guiarem seu amor</strong> no <strong>Synas</strong>!',
                cta: 'Encontrar meu par'
            }
        }
    },

    lovemap: {
        learnMore: 'Saiba Mais',
        angelAlt: 'Imagem de um cúpido',

        intro: {
            details: 'Análise personalizada ✦ 120 páginas',
            detailsBonus: 'Acesso vitalício ✦ Bônus exclusivo'
        },

        bar: {
            message: 'Descubra o amor em <strong>todas as suas nuances!</strong>',
            messageValentines: 'Mapa do Amor por <strong>METADE DO PREÇO!</strong>',
            button: 'Mapa do Amor com 50% de desconto ',
            miniButton: 'Saiba mais',
            miniButtonBf: 'Saber mais',
            miniButtonCw: 'Aproveitar última chance!'
        },

        modal: {
            countdown: 'A promoção acaba em <strong>{timer}</strong>',
            description:
                '<strong>Um mergulho profundo no seu coração!</strong> O Mapa do Amor traz uma análise exclusiva e personalizada sobre suas emoções, desejos e relações',
            discount: '<strong>CYBER WEEK: 50% DE DESCONTO</strong>',
            listItems: {
                item1: '120 páginas de conteúdo didático e ilustrado',
                item2: 'Análise personalizada para o seu Mapa Astral',
                item3: 'Identifique vulnerabilidades e evite armadilhas emocionais',
                item4: 'Descubra seus padrões emocionais e comportamentais',
                item5: 'Bônus! Dicas e reflexões sobre fim de relacionamentos e relações tóxicas'
            },
            learnMoreBf: 'Quero aproveitar!',
            logoAlt: 'Logo do Mapa do Amor',
            astroLogoAlt: 'Logo do Astrolink',
            imageAlt:
                'Ilustração de um coração com símbolos astrológicos e figuras de cupidos e planetas, representando um mapa do amor com um fundo cósmico.'
        }
    },

    blackFriday: {
        clockIconAlt: 'Ícone de relógio',
        logoBfAlt: 'Logo da Black Friday',
        unloggedBfMessage: 'Cadastre-se <br/>e aproveite!',

        bar: {
            limitedTimeOnly: 'Por tempo limitado!',
            limitedDiscount: {
                discount: '75% OFF',
                limitedTime: 'Por tempo limitado!'
            }
        }
    },

    tarot: {
        modal: {
            title: 'A resposta que você procura está nas cartas!',
            description: 'O Tarot traz revelações para você - seja premium e tenha perguntas ilimitadas',
            cta: 'Quero consultar o Tarot!',
            logoAlt: 'Logo do Astrolink',
            cards: {
                card1Title: 'Tarot Tradicional',
                card1Content:
                    'Tiragens para orientações e respostas sobre qualquer tema, como trabalho, dinheiro, família e muito mais',
                card2Title: 'Tarot do Amor',
                card2Content: 'Interpretações específicas para te guiar em perguntas sobre amor e relacionamento',
                card3Title: 'Conselhos Personalizados',
                card3Content:
                    'Pergunte o que quiser e receba conselhos do nosso assistente de Inteligência Artificial com base nas interpretações do tarot',
                card3New: 'Novo'
            }
        },

        bar: {
            desktop: 'A resposta que você procura está nas cartas do Tarot!',
            mobile: 'O Tarot tem a resposta que você procura!',
            cta: 'Saiba mais'
        }
    },

    synastry: {
        modal: {
            title: 'Você e a pessoa amada combinam de verdade?',
            description: 'Conheça a ferramenta que desvenda o futuro do seu amor e te guia para relações felizes.',
            cta: 'Ver Compatibilidade agora!',
            logoAlt: 'Logo do Astrolink',
            heroAlt: 'Compatibilidade Astral',
            heroTitle: 'Faça sua <strong>Compatibilidade Astral</strong> com quem você quiser!',
            you: 'Você',
            lovedOne: 'Pessoa amada',
            unlockNowWithCard: 'Desbloquear agora com cartão',
            unlockNowWithPix: 'Desbloquear com PIX',
            cards: {
                card1Title: 'Compatibilidade com Mapas Extras',
                card1Content: 'Adicione mapas extras ilimitados e veja sua compatibilidade astrológica com cada um.',
                card2Title: 'Análises Personalizadas',
                card2Content:
                    'Relatório completo com orientações sobre como lidar com os desafios e potencializar as qualidades de cada relação.',
                card3Title: 'Conexões além do amor',
                card3Content: 'Use a sinastria para amigos, família, relações passadas e quem mais você quiser.'
            }
        },

        bar: {
            desktop: 'Faça sua Compatibilidade Astral com quem você quiser!',
            mobile: 'Descubra agora a<br/>Compatibilidade Astral',
            cta: 'Saiba Mais'
        }
    },

    cyberMonday: {
        bar: {
            price: 'Desconto especial',
            limited_time: 'Última chance!',
            shortPremiumMessage: '75% OFF'
        }
    },

    guide2026: {
        bannerCTA: 'ACESSE AGORA',
        bePremium: 'Seja Premium e desbloqueie agora<br/>esse e vários outros benefícios!',
        isPremium: 'Você já tem acesso a esse conteúdo',

        barCTA: {
            desktop: 'ACESSE AGORA',
            mobile: 'ACESSE'
        },

        intro: {
            title: 'Ainda dá tempo de mudar de vida em 2026!',
            details: 'Previsões ✦ Artigos ✦ Calendários',
            detailsAudio: 'Agora também em áudio!',
            personalForecast: 'Previsões Pessoais',
            tarotAndCalendar: 'Tarot - Calendário Lunar',
            yearNumerology: 'Numerologia do Ano',
            articlesAndMore: 'Artigos sobre 2026 e mais!'
        },

        selection: {
            chooseAPlan: '<strong>Escolha seu plano ideal</strong><br/>para prosseguir:'
        }
    },

    careerMap: {
        bar: {
            alt: 'Mapa Astral de Carreira',
            message: 'Uma leitura personalizada sobre <strong>trabalho, propósito e dinheiro</strong>',
            button: 'Saber mais',
            buttonMobile: 'Descubra seu Mapa Astral de Carreira'
        },

        modal: {
            highlight: 'Um mapa para levar você à sua realização profissional e financeira',
            subtitle:
                'Sua análise de carreira personalizada já está pronta. Conheça seus talentos, sua forma de liderar e o caminho que te leva mais rápido para a estabilidade e a prosperidade que você busca.',

            offerBadge: {
                subscriber: 'Desconto exclusivo para cliente Premium',
                nonSubscriber: 'Promoção especial'
            },
            priceLabel: 'Acesso completo por apenas:',
            from: '<del>De {fullPrice}</del> por apenas:',
            details: 'Análise personalizada ✦ Acesso vitalício'
        }
    },

    downloadBanner: {
        title: 'Baixe o app agora!',
        description: 'Seu mapa astral completo está disponível no aplicativo do Astrolink',
        googlePlayButton: 'Baixar na Google Play Store',
        appStoreButton: 'Baixar na App Store',
        downloadAppNow: 'Baixe o app agora'
    }
};
